import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  fieldLabel: { marginRight: 16 },
  input: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 45,
    '& #input-error': {
      fontSize: 12,
      marginTop: 0,
      position: 'absolute',
      width: 'max-content',
    },
  },
  select: {
    margin: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      margin: 6,
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        margin: 6,
      }),
    },

    '& .MuiFormControl-root#select': {
      '& > div': {
        borderRadius: '10px !important',
        color: theme.palette.black,
        fontWeight: 400,

        '& .MuiSelect-select > span': {
          fontSize: 16,
          fontWeight: 400,
          [theme.breakpoints.down('md')]: {
            fontSize: 14,
          },
          [theme.breakpoints.downLandscape('md')]: {
            ...(theme.isMobileDevice && {
              fontSize: 14,
            }),
          },
        },
      },
      '& fieldset': {
        border: `1px solid ${theme.palette.grey1}`,
        backgroundColor: 'initial',
      },
    },
  },
  container: {
    alignItems: 'center',
    display: 'flex',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap',
      fontSize: 14,
      letterSpacing: '0.1px',
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        flexWrap: 'wrap',
        fontSize: 14,
        letterSpacing: '0.1px',
      }),
    },
  },
  multipleSelect: {
    margin: theme.spacing(1),
    '&#select .MuiInputBase-formControl': {
      '& #multiple-select > span': {
        fontSize: 16,
        color: theme.palette.grey1,
        fontWeight: 400,
        [theme.breakpoints.down('md')]: {
          fontSize: 14,
        },
        [theme.breakpoints.downLandscape('md')]: {
          ...(theme.isMobileDevice && {
            fontSize: 14,
          }),
        },
      },
      borderRadius: '10px !important',
      color: theme.palette.black,
      fontWeight: 400,

      '& fieldset': {
        border: `1px solid ${theme.palette.grey1}`,
        backgroundColor: 'initial',
      },
    },
  },
  disclaimer: {
    left: 380,
    top: -12,
    [theme.breakpoints.down('lg')]: {
      top: '50%',
      transform: 'translateY(-50%)',
    },
    [theme.breakpoints.down('md')]: {
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1),
      marginLeft: -6,
      position: 'initial',
      transform: 'none',
      width: 'min-content',
    },
  },
}));
